// extracted by mini-css-extract-plugin
export default {"import_wizard_choose_columns":"ImportWizardChooseColumns_import_wizard_choose_columns__HqG2h","spin":"ImportWizardChooseColumns_spin__Hlbjh"};